import { IJobsSearchPostingDateFields } from "./@types/contentful";
import { createContext, Dispatch, SetStateAction } from "react";
import { IndexUiState, UiState } from "instantsearch.js";

type QuickJobsContextProps = {
  postedDatesSchema?: IJobsSearchPostingDateFields;
};

type FeaturedJobsContextProps = {
  postedDatesSchema?: IJobsSearchPostingDateFields;
};

type ContextProps = {
  setIsFormSubmitted?: Dispatch<SetStateAction<boolean>>;
  setAutocompleteQuery?: Dispatch<SetStateAction<string>>;
  autocompleteQuery?: string;
  postedDatesSchema?: IJobsSearchPostingDateFields;
};

export const RefinedSearchContext = createContext<ContextProps>({});
export const QuickJobsContext = createContext<QuickJobsContextProps>({});
export const FeaturedJobsContext = createContext<FeaturedJobsContextProps>({});